<script setup lang="ts">
definePageMeta({
  layout: false
})

useHead({
  bodyAttrs: {
    class: 'app'
  }
})

const localePath = useLocalePath()
</script>

<template>
  <div class="error d-table-cell mx-auto text-center align-middle">
    <div class="row mx-auto">
      <div class="col-12 mb-2">
        <h3 class="font-weight-bold">
          Sorry, we couldn't find the page!
          <br />
          <span class="sec-title">抱歉，我們找不到此頁面</span>
        </h3>
      </div>
      <div class="col-12">
        <nuxt-link
          class="btn btn-primary btn-white min-w-180"
          :to="localePath('index')"
        >
          Go Back Home
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '~/assets/app/scss/index';
</style>
